import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import AuthPage from './components/AuthPage/AuthPage';
import Dashboard from './components/Dashboard/Dashboard';
import Settings from './components/Settings/Settings';
import EmailVerification from './components/EmailVerification/EmailVerification';
import EmailChangeVerification from './components/EmailChangeVerification/EmailChangeVerification';
import TermsOfService from './components/TermsOfService/TermsOfService';
import OracleFlow from './components/OracleFlow/OracleFlow';
// FUTURE FEATURE: Password reset functionality - commented out for Phase 1 MVP
// import PasswordReset from './components/PasswordReset/PasswordReset';
import LightRays from './components/LightRays/LightRays';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

const BackgroundManager = () => {
  const location = useLocation();
  
  // Show LightRays for pre-oracle routes (auth, dashboard, settings, verify-email, verify-email-change, terms-of-service, root)
  // FUTURE: Add '/password-reset' when password reset feature is enabled
  const isPreOracleRoute = ['/auth', '/dashboard', '/settings', '/verify-email', '/verify-email-change', '/terms-of-service', '/'].includes(location.pathname);
  
  if (isPreOracleRoute) {
    return (
      <LightRays
        raysOrigin="top-center"
        raysColor="#00ffff"
        raysSpeed={1.5}
        lightSpread={0.8}
        rayLength={1.2}
        followMouse={true}
        mouseInfluence={0.1}
        noiseAmount={0.1}
        distortion={0.05}
        className="app-background-rays"
      />
    );
  }
  
  // For oracle routes, background will be handled by OracleFlow component
  return null;
};

function App() {
  // FUTURE THEME EXPANSION: This will be dynamic based on user selections
  // Currently hardcoded to 'basic-theme' (unisex+none default)
  // Future: className={`oracle-container ${dynamicTheme}-theme`}
  return (
    <div className="oracle-container basic-theme" style={{ width: '100%', height: '100vh', position: 'relative' }}>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <BackgroundManager />
          <Routes>
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/settings" element={<Settings />} />
            {/* TD3-123: Email verification route */}
            <Route path="/verify-email" element={<EmailVerification />} />
            {/* TD3-129: Email change verification route (LGPD compliance) */}
            <Route path="/verify-email-change" element={<EmailChangeVerification />} />
            {/* TD3-151: Terms of Service page */}
            <Route path="/terms-of-service" element={<TermsOfService />} />
            {/* FUTURE FEATURE: Password reset route - commented out for Phase 1 MVP */}
            {/* <Route path="/password-reset" element={<PasswordReset />} /> */}
            <Route path="/oracle/:sessionId" element={<OracleFlow />} />
            <Route path="/" element={<Navigate to="/auth" replace />} />
            {/* TD3-198: Catch-all route for unmatched paths (e.g., /oracle without sessionId) */}
            <Route path="*" element={<Navigate to="/auth" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;